import { useFetch } from 'plume-web-utils';

import { DependencyContainer } from '../../../DependencyContainer';

import { useRecoilValue } from 'recoil';
import { activePartnerAtom } from '../../../state';
import { UseFetchCacheKeys } from '../../../cacheConfig';

const { configurationService } = new DependencyContainer();

const useEmailLanguages = () => {
  const activePartner = useRecoilValue(activePartnerAtom);

  return useFetch(
    () => configurationService.getEmailLanguages(activePartner?.id || ''),
    {
      skip: !activePartner?.id,
      dependencies: [activePartner?.id],
      cacheKey: UseFetchCacheKeys.EmailLanguages,
    },
  );
};

export default useEmailLanguages;
